//
//
//
//
//
//
//
//
//

export default {
  props: {
    url: {
      default: null
    },
    event: {
      default: null
    }
  }
}
